<ul *ngIf="fascicolo && pratica">
  
    <ng-template
      [ngIf]="true">
  
      <li
        *ngIf="writable">
        <a href="javascript:void(0);" (click)="onClickOption('add');">
          <span class="glyphicon glyphicon-plus"></span>Aggiungi documento</a>
      </li>
  
      <li
        *ngIf="!writable"
        class="disabilitata"><span class="glyphicon glyphicon-plus"></span>Aggiungi documento</li>
    </ng-template>
  
    <ng-template [ngIf]="true">
  
      <li
        *ngIf="writable">
        <a href="javascript:void(0);" (click)="onClickOption('edit');">
          <span class="glyphicon glyphicon-edit"></span>Modifica censimento</a>
      </li>
      <li
        *ngIf="!writable"
        class="disabilitata"><span class="glyphicon glyphicon-edit"></span>Modifica censimento</li>
    </ng-template>
  
    <ng-template [ngIf]="true">
  
        <li
          *ngIf="writable && canDeleteTipoDocumento">
          <a href="javascript:void(0);" (click)="onClickOption('delete');">
            <span class="glyphicon glyphicon-trash"></span>Elimina censimento</a>
        </li>
        <li
          *ngIf="!writable || !canDeleteTipoDocumento"
          class="disabilitata"><span class="glyphicon glyphicon-trash"></span>Elimina censimento</li>
      </ng-template>
  
  
</ul>